module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// ./options/sitepage/cancellation.js
// module id = 1136
// module chunks = 4